<template>
  <div id="app">
    <Main />
  </div>
</template>

<script>
import Main from './components/Main.vue'



export default {
  name: 'app',
  components: {
    Main
  }
}
</script>

<style lang="scss">
@font-face {
    font-family: AlmiraRegular;
    src: url("./assets/fonts/AlmiraRegular.woff") format("woff");
}
@font-face {
    font-family: AlmiraBold;
    src: url("./assets/fonts/AlmiraBold.woff") format("woff");
}

*
{

  margin:0 !important;
  outline:0;
  box-sizing: border-box;
}

body
{  
  margin:0;
  padding:0;
  overflow:hidden !important;
  background:#000; 
}

#app {
  position:absolute;
  height:1920px;
  width:1080px;
  left:50%;
  top:50%;  
  overflow:hidden !important;
}
</style>
